"use strict";

exports.__esModule = true;
exports.widthToColumns = exports.countToColumns = void 0;

const px = n => typeof n === 'number' ? `${n}px` : n;

const widthToColumns = width => {
  if (Array.isArray(width)) {
    return width.map(item => widthToColumns(item));
  }

  return !!width && `repeat(auto-fit, minmax(${px(width)}, 1fr))`;
};

exports.widthToColumns = widthToColumns;

const countToColumns = count => {
  if (Array.isArray(count)) {
    return count.map(item => countToColumns(item));
  }

  return !!count && typeof count === 'number' ? `repeat(${String(count)}, 1fr)` : String(count);
};

exports.countToColumns = countToColumns;